import axios from 'axios';
import { Auth } from './Auth';
import { LanguageService } from './LanguageService';
import Utils from './Utils';
import { RestPath } from '../constants/SitePaths';
import { refreshToken, refreshTokenBegin } from '../actions/UserActions';
import store from '../index';
import { ErrorType } from '../constants/Errors/ErrorTypes';
import { closeProfileTabsPopup } from '../actions/ControlsAction';
import { Browser } from './helpers/Browser';
import config from '../constants/Configs';
import { LocalStorageService } from './LocalStorageService';
import UniqueUserIdService from './uniqueUserId/UniqueUserIdService';
import StringHelper from './helpers/StringHelper'
// Add a request interceptor
axios.interceptors.request.use(function (axiosConfig) {
    // Do something before request is sent
    // axiosConfig.withCredentials = true
    const authData = Auth.fillAndGetData();
    const token = Utils.getTokenFromLocalStorage();
    const selecteLanguage = LanguageService.getSelectedLanguage() || LanguageService.getSelectedLanguageFromLocalStorage();
    axiosConfig.headers['deviceType'] = Browser.getHeaderDeviceType();
    const isPreviewSiteApi = Browser.isAbsoluteURL(axiosConfig?.url);

    if (isPreviewSiteApi) {
        const token = StringHelper.fnv1a(Browser.getDomain() + config.CACHE_VERSION);
        if (axiosConfig?.params) {
            axiosConfig.params["t"] = token;
        } else {
            axiosConfig.params = { t: token };
        }
    }

    if (axiosConfig.headers['grant_type'] !== 'refresh_token') {
        //Set access token
        if (authData && authData.token) {
            //if (!config.NEW_PLAT || (config.NEW_PLAT && axiosConfig?.url.includes(RestPath.LOGIN))) {
            // hardcode for new plat getSettings request
            axiosConfig.headers['Authorization'] = 'Bearer ' + authData.token;
            // }
        }

        //Set selected language
        if (selecteLanguage) {
            axiosConfig.headers['accept-language'] = selecteLanguage;
            // axiosConfig.headers['language'] = selecteLanguage
        }

        if (token) {
            axiosConfig.headers['_ga_anl_cf3q'] = token;
        }
        if (!axiosConfig.url.endsWith('/token')) {
            axiosConfig.headers['uniqueId'] = UniqueUserIdService.getUniqueUserId();
        }
        // if (isPreviewSiteApi) {
        axiosConfig.headers['Cache-Control'] = 'no-cache';
        // }

        // if (!axiosConfig.url?.includes('/Translation/GetTranslations')) {
        //     axiosConfig.headers['Cache-Control'] = 'no-cache';
        // }else{
        //     axiosConfig.headers['Cache-Control'] = 'max-age=5';
        // }

        axiosConfig.headers['TimeZone'] = Utils.getTimeZone();
        //Set default content type
        if (!axiosConfig.headers['Content-Type'] || axiosConfig.headers['Content-Type'] === 'text/plain;charset=UTF-8') {
            axiosConfig.headers['Content-Type'] = config.REACT_APP_HEADER_CONTENT_TYPE
        }
    } else {
        delete axiosConfig.headers['grant_type'];
    }
    //By Centrivo's request
    if (config.NEW_PLAT && axiosConfig?.url.includes(RestPath.LOGIN)) {
        delete axiosConfig.headers['Authorization'];
    }
    return axiosConfig;

}, function (error) {
    // Do something with request error
    return Promise.reject(error);
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const errorStatus = error?.response?.status;
    if (error.config.data) {
        let data = Utils.parseQuery(error.config.data);
        if (data && data.grant_type === "refresh_token") {
            Auth.invalidateSession();
            window.location.reload();
        }
    }
    if (error && error.response && errorStatus === 401) {
        store.dispatch(refreshTokenBegin());
        let authData = Auth.fillAndGetData();
        const { config } = error;
        const originalRequest = config;
        if (authData && authData.refreshToken) {
            // Do not refresh token for interval calls and stop interval until token will be refreshed
            if ((originalRequest.url.indexOf(RestPath.GET_PLAYER_BALANCE) === -1 && originalRequest.url.indexOf(RestPath.GET_ACCOUNT_BALANCE) === -1) || Utils.isGameUrl()) {
                // store.dispatch(refreshToken(authData, originalRequest, Auth))
                return refreshToken(authData, originalRequest, Auth);
            }
        } else {
            Auth.invalidateSession();
            store.dispatch(closeProfileTabsPopup(store.getState().ui));
            // window.location.reload()
        }
        //Detect JS Chalange and redirect user to pass it    
    } else if ((errorStatus === 503 || errorStatus === 403 || errorStatus === 429) && error?.response?.data?.indexOf('challenge') > -1) {
        let underAttack = LocalStorageService.get("under_attack");
        if (!underAttack) {
            LocalStorageService.set("under_attack", true, { ttl: 30 });
            const domain = Browser.getDomain();
            const challengeUrl = `https://${domain}${config.BASE_URL}/challenge/processing`;
            window.location.href = challengeUrl;
        }
    } else if (error && error.response && errorStatus >= 400) {
        const result = error.response.data;
        // Handled error on backend side 
        if (result && result.code && result.message) {
            //Wrong auth token or project
            if (result.code === ErrorType.WRONG_AUTH_TOKEN) {
                Auth.invalidateSession();
                window.location.reload();
                // store.dispatch(closeProfileTabsPopup(store.getState().ui))
            }
        }
    }
    return Promise.reject(error);
});
